import { GridColumnProps } from "@progress/kendo-react-grid";
import { CLASSNAME, COLOR } from "utils/constant";
import { GrideDateFormatter } from "ui/Date";
import { NumericalCell, NumericalHeader } from "ui/grid/GridCommandCell";
import { t } from "i18next";
import CellPopover from "ui/grid/DescriptionCell";

export const landingNoteJournalGridColumns = () => {
	const gridItems: GridColumnProps[] = [
		{
			field: "noteNumber",
			title: t("LandingNoteNumber"),
			width: "170px",
			headerClassName: "no-border",
		},

		{
			field: "lineNumber",
			title: t("Line"),
			width: "80px",
			headerClassName: "no-border",
		},
		{
			field: "product",
			title: t("Species"),
			width: "300px",
			headerClassName: "no-border",
			cells: {
				data: (props) => <CellPopover {...props} />,
			},
		},
		{
			field: "packaging",
			width: 150,
			title: t("Packaging"),
			headerClassName: "no-border",
			cells: {
				data: (props) => <CellPopover {...props} />,
			},
		},
		{
			field: "averageLiveWeightKg",
			title: t("AverageWeight"),
			width: "150px",
			cells: {
				data: (props) => <NumericalCell {...props} />,
				headerCell: (props) => <NumericalHeader {...props} />,
			},

			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
			// headerCell: (props) => <NumericalHeader {...props} />,
		},
		{
			field: "netLiveWeightKg",
			title: t("TotalWeight"),
			width: "150px",
			cells: {
				data: (props) => <NumericalCell {...props} unit={"kg"} />,
				headerCell: (props) => <NumericalHeader {...props} />,
			},

			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
			// headerCell: (props) => <NumericalHeader {...props} />,
		},
		{
			field: "registrationId",
			title: t("RegistrationIdShort"),
			width: "150px",
			cells: {
				data: (props) => <NumericalCell {...props} formatDecimal={0} />,
				headerCell: (props) => <NumericalHeader {...props} />,
			},

			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
			// headerCell: (props) => <NumericalHeader {...props} />,
		},

		{
			field: "vesselRegistrationId",
			title: t("VesselRegistrationId"),
			width: "120px",
		},
		{
			field: "vesselName",
			title: t("VesselName"),
			width: "170px",

			cells: {
				data: (props) => <CellPopover {...props} />,
			},
		},
		{
			field: "fishermanName",
			title: t("FishermanName"),
			width: "170px",

			cells: {
				data: (props) => <CellPopover {...props} />,
			},
		},
		{
			field: "fishingGear",
			title: t("FishingGear"),
			width: "170px",

			cells: {
				data: (props) => <CellPopover {...props} />,
			},
		},

		{
			field: "landingTime",
			title: t("DeliveryDate"),
			width: "130px",
			headerClassName: "no-border",
			cell: (props) => (
				<GrideDateFormatter
					date={props.dataItem.landingTime}
					formatType={"dd.MM.yyyy"}
				/>
			),
		},
		{
			field: "catchField",
			title: t("CatchArea"),
			width: "100px",
			headerClassName: "no-border",
		},
		{
			field: "catchAreaZone",
			title: t("Zone"),
			width: "80px",
			headerClassName: "no-border",
		},

		{
			field: "quotaTypeCode",
			title: t("Quota"),
			width: "80px",
			headerClassName: "no-border",
		},
		{
			field: "",
			width: "30",
		},
	];
	return gridItems;
};
